import Vue from 'vue'
import Vuex from 'vuex'
import { object, list } from 'rxfire/database'
// import {filter} from 'rxjs/_esm5/internal/operators'
import router from '../router'
import { map } from 'rxjs/operators'
import { initLanguage } from './plugins/localStorage'
import variables from '@/custom/variables'
const fb = require('@/services/firebaseConfig.js')

Vue.use(Vuex)

let profile, userJobs, categories, location, payments
let newEntry = true
// handle page reload
fb.app.auth().onAuthStateChanged(user => {
  store.commit('toggleLoading', { key: 'splash', value: true })

  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')
    store.commit('toggleLoading', { key: 'userJobs', value: true })
    store.dispatch('fetchUserJobs')
    store.dispatch('fetchPayments')
    store.dispatch('fetchCategories')

    // if (fb.pushToken !== null) {
    //   fb.database.ref(`/user/${user.uid}/profile/pushToken`).set(fb.pushToken)
    // } else {
    //   fb.database.ref(`/user/${user.uid}/profile/pushToken`).set(false)
    // }
    newEntry = false
  } else if (!newEntry) {
    store.dispatch('clearData')
    store.commit('toggleLoading', { key: 'splash', value: false })
    router.push(`/login`).catch(() => {})
  } else {
    store.dispatch('clearData')

    store.commit('toggleLoading', { key: 'splash', value: false })
    router.push(`/login`).catch(() => {})
  }
})

export const store = new Vuex.Store({
  state: {
    version: '2.0.3',
    language: initLanguage,
    currentUser: null,
    userProfile: {},
    filteredCategories: [],
    categories: [],
    jobs: [],
    userJobs: [],
    location: {},
    geofireQuery: null,
    loading: false,
    jobLoading: false,
    userPayments: [],
    customerPayments: [],
    // Gonna have to implement it roughly since there are no getters and it's the state that is being mapped
    status: {
      loading: {
        currentUser: true,
        userProfile: false,
        jobs: true,
        userJobs: true,
        splash: true
      }
    },
    addDialog: false,
    openSettings: false,
    openJob: false,
    chatSelection: {},
    chatOpen: false,
    timeSelection: {},
    timeOpen: false
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('setLanguage', language)
    },

    initData ({ commit }, getData) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          store.dispatch(getData)
          resolve()
        }, 0)
      })
    },

    async clearData ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setCurrentUser', null)
        commit('setUserProfile', {})
        profile.unsubscribe()
        userJobs.unsubscribe()
        categories.unsubscribe()
        location.unsubscribe()
        payments.unsubscribe()
        return 'done'
      })
    },

    fetchUserProfile ({ commit, state }) {
      profile = object(fb.database.ref(`user/${state.currentUser.uid}/profile`))
        .pipe(map(change => ({ _key: change.snapshot.key, ...change.snapshot.val() })))
        .subscribe(data => {
          if (Object.keys(data).length > 1) {
            commit('setUserProfile', data)
            commit('setLanguage', data.language)
            if (data.firstEntry && router.history.current.name !== 'Registration') {
              router.history.current.query.step = router.history.current.query.step ? parseInt(router.history.current.query.step) : 1

              router.push({
                path: '/registration',
                query: router.history.current.query
              }).catch(() => {})
              setTimeout(() => {
                store.commit('toggleLoading', {
                  key: 'splash',
                  value: false
                })
                store.commit('toggleLoading', {
                  key: 'userProfile',
                  value: true
                })
              }, 4000)
            } else if (!data.firstEntry && router.history.current.name === 'stripe-registration') {
              router.push({
                path: '/stripe-registration',
                query: router.history.current.query
              }).catch(() => {})
              setTimeout(() => {
                store.commit('toggleLoading', {
                  key: 'splash',
                  value: false
                })
                store.commit('toggleLoading', {
                  key: 'userProfile',
                  value: true
                })
              }, 2000)
            } else if (!data.firstEntry && router.history.current.name === 'Login') {
              if (data.userType.refer) {
                router.push({
                  path: '/referrals',
                  query: router.history.current.query
                }).catch(() => {})
              } else {
                router.push({
                  path: '/dashboard',
                  query: router.history.current.query
                }).catch(() => {})
              }

              setTimeout(() => {
                store.commit('toggleLoading', {
                  key: 'splash',
                  value: false
                })
                store.commit('toggleLoading', {
                  key: 'userProfile',
                  value: true
                })
              }, 2000)
            } else {
              setTimeout(() => {
                store.commit('toggleLoading', {
                  key: 'splash',
                  value: false
                })
                store.commit('toggleLoading', {
                  key: 'userProfile',
                  value: true
                })
              }, 4000)
            }
          }
        })
    },

    fetchUserJobs ({ commit, state }) {
      userJobs = list(fb.database.ref(`user/${state.currentUser.uid}/jobs`))
        .pipe(
          map(changes => changes.map(c => {
            return { _key: c.snapshot.key, event: c.event, ...c.snapshot.val() }
          }))).subscribe(jobs => {
          commit('setUserJobs', jobs)
          // store.commit('setJobLoading', false)
          store.commit('toggleLoading', { key: 'userJobs', value: false })
        })
    },

    fetchCategories ({ commit, state }) {
      categories = list(fb.database.ref(`categories`))
        .pipe(
          map(changes => changes.map(c => {
            return { _key: c.snapshot.key, event: c.event, ...c.snapshot.val() }
          }))).subscribe(categories => {
          categories.push({ _key: 'Other' })
          commit('setCategories', categories)
        })
    },

    fetchLocation ({ commit, state }) {
      location = object(fb.database.ref(`user/${state.currentUser.uid}/profile/location`))
        .pipe(map(change => ({ _key: change.snapshot.key, ...change.snapshot.val() })))
        .subscribe(data => {
          // console.log('location', data)
          // for some reason this is returinig data.distance as "distance:1e+41" which then later gets parsed to int and becomes 1,
          // I guess that's why no jobs were being found.
          commit('setUserLocation', data)
          store.dispatch('fetchJobs', {
            coords: data.coords,
            distance: parseInt(data.distance)
          })
        })
    },

    fetchPublicLocation ({
      commit,
      state
    }, payload) {
      commit('setUserLocation', payload)
      store.dispatch('fetchJobs', {
        coords: payload.coords,
        distance: parseInt(payload.distance)
      })
    },

    fetchPayments ({ commit, state }) {
      payments = list(fb.database.ref(`user/${state.currentUser.uid}/payments/transactions`))
        .pipe(map(changes => changes.map(c => {
          return { _key: c.snapshot.key, event: c.event, ...c.snapshot.val() }
        }))).subscribe(data => {
          // console.log(data, 'location')
          commit('setUserPayments', data)
        })
    },

    fetchCustomerPayments ({ commit, state }) {
      payments = list(fb.database.ref(`user/${state.currentUser.uid}/customerPayments/transactions`))
        .pipe(map(changes => changes.map(c => {
          return { _key: c.snapshot.key, event: c.event, ...c.snapshot.val() }
        }))).subscribe(data => {
          // console.log(data, 'location')
          commit('setCustomerPayments', data)
        })
    },

    async fetchJobs ({ commit, state }, payload) {
      // console.log('state.geofireQuery', state.geofireQuery)
      commit('toggleLoading', { key: 'jobs', value: true })
      if (state.geofireQuery !== null) {
        state.geofireQuery.updateCriteria({
          center: payload.coords,
          radius: (payload.distance * 1.60934)
        })
      } else {
        state.geofireQuery = fb.geoFireApp.query({
          center: state.location.coords,
          radius: (payload.distance * 1.60934)
        })

        state.geofireQuery.on('key_entered', (key, location, distance) => {
          fb.database.ref(`jobs/${key}/public`).on('value', function (snapshot) {
            var val = snapshot.val()
            if (val !== null) {
              val.dist = (Math.round((distance / 1.60934) * 10) / 10)

              var jobIndex = state.jobs.findIndex(x => x._key === val._key)
              if (jobIndex === -1) {
                commit('setJobs', val, key)
              } else {
                val.jobIndex = jobIndex
                commit('editJob', val)
              }
            }
          })
        })

        state.geofireQuery.on('key_exited', (key, location, distance) => {
          fb.database.ref(`jobs/${key}`).off()
          commit('removeJobs', key)
          commit('toggleLoading', { key: 'jobs', value: false })
        })
      }
      commit('toggleLoading', { key: 'jobs', value: false })
    },

    sortJobs ({ commit, state }, payload) {
      commit('removeJobs', payload)
    },
    openAddDialog ({ commit, state }, payload) {
      commit('setAddDialog', new Date())
    },
    openSettingsDialog ({ commit, state }, payload) {
      commit('setSettingsDialog', new Date())
    },
    openJobDialog ({ commit, state }, payload) {
      commit('setJobDialog', payload)
    },
    changeChatSelection ({ commit, state }, payload) {
      commit('setChatSelection', payload)
    },
    changeTimeSelection ({ commit, state }, payload) {
      commit('setTimeSelection', payload)
    }
  },

  mutations: {
    setLanguage (state, language) {
      Vue.set(state, 'language', language)
      Vue.prototype.$language = variables.data[language]
    },

    setCurrentUser (state, val) {
      state.currentUser = val
    },

    setUserProfile (state, val) {
      store.commit('toggleLoading', { key: 'userProfile', value: false })
      // val.profileLoaded = true
      state.userProfile = val
      if (val.categories !== undefined) {
        state.filteredCategories = Object.keys(val.categories).map(key => {
          // if (val.categories[key]) {
          return key
          // return {_key: key, value: val.categories[key]}
          // }
        })
      }
    },

    setCategories (state, val) {
      state.categories = val
    },

    setUserLocation (state, val) {
      state.location = val
    },

    setJobs (state, val, key) {
      state.jobs.push(val)
    },

    editJob (state, val, jobIndex) {
      // console.log(val)
      state.jobs.splice(val.jobIndex, 1)
      state.jobs.push(val)
    },

    removeJobs (state, key) {
      let removeIndex = state.jobs.findIndex(x => x.key === key)
      state.jobs.splice(removeIndex, 1)
    },

    setUserJobs (state, val) {
      state.userJobs = val
    },

    setUserPayments (state, val) {
      state.userPayments = val
    },
    setCustomerPayments (state, val) {
      state.customerPayments = val
    },

    toggleLoading (state, val) {
      state.status.loading[val.key] = val.value
    },

    setJobLoading (state, val) {
      state.jobLoading = val
    },

    setAddDialog (state, val) {
      state.addDialog = val
    },

    setSettingsDialog (state, val) {
      state.openSettings = val
    },

    setJobDialog (state, val) {
      state.openJob = val
    },
    setChatSelection (state, val) {
      state.chatSelection = val
    },
    setChatOpen (state, val) {
      state.chatOpen = val
    },
    setTimeSelection (state, val) {
      state.timeSelection = val
    },
    setTimeOpen (state, val) {
      state.timeOpen = val
    }

  },

  getters: {
    getLanguage (state) {
      return (state || {}).language || 'en'
    }
  }
})

export default store
